import {
  Component,
  Input,
  ChangeDetectionStrategy, Output, EventEmitter
} from '@angular/core';

import { LMModel } from '@form/model';

@Component({
  selector: 'lm-fileupload',
  standalone: false,
  templateUrl: 'lm-fileupload.component.html',
  styleUrls: [ 'lm-fileupload.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMFileuploadComponent {
  @Input() layoutObject: LMRadioButtonLayout | undefined;
  @Input() layoutInfo: LMFormLayoutInfo | undefined;
  @Input() lmParagraphLayoutInfo: LMParagraphLayoutInfo | undefined;
  @Input() lmColumnLayoutInfo: LMColumnLayoutInfo | undefined;
  @Input() parentCompoundFieldDisplayOnly = false;
  @Input() specFields: LMSpecFields | undefined;
  @Input() model: LMModel | undefined;
  @Input() placeHolder: any;

  @Output() fieldEvent: EventEmitter<LMFieldEvent> = new EventEmitter<LMFieldEvent>();

  onFieldEvent($event: LMFieldEvent) {
    this.fieldEvent.emit($event);
  }
}
